import { render, staticRenderFns } from "./Extension-Log.vue?vue&type=template&id=c80c88f0"
import script from "./Extension-Log.vue?vue&type=script&lang=js"
export * from "./Extension-Log.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports